module.exports = __webpack_public_path__ + "img/instagram.bf6af1b5.svg";